// R-NAV1-OP — OperatorMobileLayout.tsx
//
// FASE 0 (lettura App.tsx): le route `/app/*` usano AppShellPage come layout (Outlet) dentro ProtectedRoute.
// Il ruolo è disponibile tramite useAuth() (contesto popolato dal JWT / sessione prodotto).
// Profile e Planning sono già definiti in App.tsx come lazy; questo wrapper non tocca auth né AppShell.
//
// Comportamento: solo utenti OPERATORE su mobile ricevono padding-bottom e OperatorBottomNav fissa;
// altri ruoli ottengono solo <Outlet /> senza alterazioni visive.

import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  OperatorBottomNav,
  OPERATOR_BOTTOM_NAV_SX_PADDING,
  resolveOperatorBottomNavTab,
} from '../components/navigation/OperatorBottomNav';

export function OperatorMobileLayout() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isOperatore = user?.role === 'OPERATORE';
  const activeTab = resolveOperatorBottomNavTab(pathname);

  if (!isOperatore) {
    return <Outlet />;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      <Box sx={{ flex: 1, ...OPERATOR_BOTTOM_NAV_SX_PADDING }}>
        <Outlet />
      </Box>
      <OperatorBottomNav active={activeTab} />
    </Box>
  );
}
